import React, { useState } from "react";

export const StepShell = ({ n, label, title, id, tone = "", children }) => (
  <section className={`flow-step reveal in-view ${tone}`} id={id || `step-${n}`} data-testid={`step-${n}`}>
    <div className="container">
      <div className="step-badge">0{n}</div>
      <div className="label">{label}</div>
      <h2>{title}</h2>
      {children}
    </div>
  </section>
);

export const AiButton = ({ onRun, label, busyLabel = "Reflecting...", testid, disabled }) => {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const run = async () => {
    setErr("");
    setBusy(true);
    try {
      await onRun();
    } catch (e) {
      setErr(e?.response?.data?.detail || e.message || "Something went wrong, try again.");
    }
    setBusy(false);
  };
  return (
    <>
      <button className={`mono-btn release-btn ${busy ? "sending ai-busy" : ""}`} onClick={run} disabled={disabled} data-testid={testid}>
        {busy ? busyLabel : label}
      </button>
      <div className="save-note" data-testid={`${testid}-note`}>{err}</div>
    </>
  );
};

export const feelingsOf = (desires) => [...new Set(desires.map((d) => d.y.trim().toLowerCase()).filter(Boolean))];

export const joinWords = (arr) => (arr.length < 2 ? arr.join("") : `${arr.slice(0, -1).join(", ")} and ${arr[arr.length - 1]}`);

export const desireContext = (desires) => desires.map((d) => `- ${d.x}${d.y ? `, to feel ${d.y}` : ""}`).join("\n");
